import { Stagger, StaggerItem } from "../common/Reveal";
import { SectionHeading } from "../common/SectionHeading";
import { process } from "../../data/content";

export const ProcessTimeline = ({ dark = true }) => (
    <section className={`relative ${dark ? "bg-navy-deep grain" : "bg-white"}`} data-testid="process-timeline">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32">
            <SectionHeading
                dark={dark}
                overline="Our Workforce Process"
                title="A structured 6-step deployment process"
                subtitle="From understanding your requirement to on-site management — a disciplined, compliance-oriented workflow."
            />
            <Stagger className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12 relative">
                {process.map((p) => (
                    <StaggerItem key={p.n}>
                        <div className="relative pl-4">
                            <div className="absolute left-0 top-0 h-full w-px bg-white/10" />
                            <div className="absolute -left-px top-1 h-8 w-1 bg-brand" />
                            <div className="flex items-center gap-4">
                                <span className={`font-display font-extrabold text-5xl ${dark ? "text-white/10" : "text-navy/10"}`}>{p.n}</span>
                                <div className="h-12 w-12 rounded-sm grid place-items-center bg-brand/15">
                                    <p.icon size={26} weight="duotone" className="text-brand" />
                                </div>
                            </div>
                            <h3 className={`mt-5 font-display font-bold text-lg tracking-tight ${dark ? "text-white" : "text-navy"}`}>{p.title}</h3>
                            <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-slate-400" : "text-slate-500"}`}>{p.desc}</p>
                        </div>
                    </StaggerItem>
                ))}
            </Stagger>
        </div>
    </section>
);
